import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {WorkOrderEditComponent} from "./work-order-edit.component";
import {WorkOrderDefaultEditComponent} from './work-order-default-edit/work-order-default-edit.component';
import {MatTabsModule} from "@angular/material/tabs";
import {GeneralDataModule} from "./work-order-default-edit/general-data/general-data.module";
import {MovementManagerModule} from "./work-order-default-edit/movement-manager/movement-manager.module";
import {CtButtonModule, CtFormGeneratorModule} from "@ctsolution/ct-framework";
import {FlexModule} from "@angular/flex-layout";
import {MatIconModule} from "@angular/material/icon";
import {MatLegacyButtonModule} from "@angular/material/legacy-button";
import {MatLegacyCardModule} from "@angular/material/legacy-card";
import {WorkOrderHandlingsModule} from "./work-order-default-edit/work-order-handlings/work-order-handlings.module";
import { WorkOrderDocumentsModule } from "./work-order-default-edit/work-order-documents/work-order-documents.module";
import { WorkOrderSummaryModule } from "./work-order-default-edit/work-order-summary/work-order-summary.module";
import { LangDownloadFileModule } from "../../lang-download-file/lang-download-file.module";
import { WorkOrderDownloadMenuModule } from "../../work-order-download-menu/work-order-download-menu.module";
import { TranslateModule } from "@ngx-translate/core";
import { WorkOrderLocationModule } from "./work-order-default-edit/work-order-location/work-order-location.module";
import { SchedulerListModule } from "../../scheduler/scheduler-list/scheduler-list.module";
import { WorkOrderDynamicFormModule } from "./work-order-default-edit/work-order-dynamic-form/work-order-dynamic-form.module";
import { WorkOrderEditTemplateModule } from "./work-order-default-edit/work-order-edit-template/work-order-edit-template.module";
import { WorkOrderTaskModule } from "./work-order-default-edit/work-order-task/work-order-task.module";
import { WorkOrderPaymentsModule } from "./work-order-default-edit/work-order-payments/work-order-payments.module";
import { WorkOrderQuotationDialogModule } from "./work-order-default-edit/work-order-quotation-dialog/work-order-quotation-dialog.module";
import { WorkOrderEventLogDialogModule } from "./work-order-default-edit/work-order-event-log-dialog/work-order-event-log-dialog.module";
import { WorkOrderCompanyInformationModule } from "./work-order-default-edit/work-order-company-information/work-order-company-information.module";

@NgModule({
  declarations: [
    WorkOrderEditComponent,
    WorkOrderDefaultEditComponent
  ],
  imports: [
    CommonModule,
    MatTabsModule,
    GeneralDataModule,
    MovementManagerModule,
    CtButtonModule,
    FlexModule,
    MatIconModule,
    MatLegacyButtonModule,
    MatLegacyCardModule,
    WorkOrderHandlingsModule,
    WorkOrderTaskModule,
    WorkOrderPaymentsModule,
    WorkOrderDocumentsModule,
    WorkOrderSummaryModule,
    LangDownloadFileModule, // Componente legacy per compatibilità
    WorkOrderDownloadMenuModule, // Nuovo componente con menu avanzato
    TranslateModule,
    WorkOrderLocationModule,
    SchedulerListModule,
    WorkOrderDynamicFormModule,
    WorkOrderEditTemplateModule,
    CtFormGeneratorModule,
    WorkOrderQuotationDialogModule,
    WorkOrderEventLogDialogModule,
    WorkOrderCompanyInformationModule
  ],
  exports: [
    WorkOrderEditComponent
  ]
})
export class WorkOrderEditModule {
}
